import { getBreakpoints } from '../utils/utils';

const header = () => document.querySelector('.header');
const { md } = getBreakpoints();

const isModalOpen = () => {
  const modal = document.getElementById('roomTourModal');
  return modal && getComputedStyle(modal).display !== 'none';
};

const isMobileViewport = () => window.innerWidth < md;

function syncHeaderZIndex() {
  const el = header();
  if (!el) {
    return;
  }

  if (isModalOpen() && isMobileViewport()) {
    el.style.setProperty('z-index', '2');
  } else {
    el.style.removeProperty('z-index');
  }
}

function openModal(url) {
  document.getElementById('iframeContent').src = url;
  document.getElementById('roomTourModal').style.display = 'flex';
  document.getElementById('roomTourOverlay').style.display = 'block';
  document.body.classList.add('overflow-hidden');
  document.body.classList.add('room-tour-open');
  syncHeaderZIndex();
  setTimeout(() => {
    document.querySelector('.accomodations__dialog__button')?.focus();
  }, 100);
}

function closeModal() {
  document.getElementById('roomTourModal').style.display = 'none';
  document.getElementById('roomTourOverlay').style.display = 'none';
  document.getElementById('iframeContent').src = '';
  document.body.classList.remove('overflow-hidden');
  document.body.classList.remove('room-tour-open');
  syncHeaderZIndex();
}

let wasMobile = isMobileViewport();

window.addEventListener('resize', () => {
  const mobile = isMobileViewport();
  if (mobile === wasMobile) {
    return;
  }
  wasMobile = mobile;
  syncHeaderZIndex();
});

document.addEventListener('DOMContentLoaded', () => {
  const accomodationsDialog = document?.querySelector('#roomTourModal');
  if (accomodationsDialog) {
    const roomTourLink = '.c-button--tour';
    const roomTourCloseBtn = '.accomodations__dialog__button';

    document.querySelectorAll(roomTourLink).forEach((item) => {
      item?.addEventListener('click', (e) => {
        e.preventDefault();
        openModal(e.currentTarget.href);
      });
    });

    document.querySelector(roomTourCloseBtn)?.addEventListener('click', closeModal);
    document.querySelector('.accomodations__dialog__overlay').addEventListener('click', closeModal);

    document.addEventListener('click', (event) => {
      if (event.target === document.getElementById('roomTourModal')) {
        closeModal();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && isModalOpen()) {
        closeModal();
      }
    });

    const guardStart = document.getElementById('focusGuardStart');
    const guardEnd = document.getElementById('focusGuardEnd');
    const iframe = document.getElementById('iframeContent');

    guardStart?.addEventListener('focus', () => {
      iframe?.focus();
    });

    guardEnd?.addEventListener('focus', () => {
      document.querySelector(roomTourCloseBtn)?.focus();
    });
  }
});